/** @format */

import { HomrBundleSpot } from './homr-bundle-spot.interface';
import { HomrGTGTContent } from './gtgt-content.interface';
import { HomrScheduleContent } from './homr-schedule-content.interface';
import { IHomrBanner } from './homr-banner.interface';
import { IHomrRichContent } from './homr-rich-content.interface';
import { IHomrSpot } from './homr-spot.interface';

export interface IHomrState {
  homrBanner?: IHomrBanner;
  homrBundleContent?: HomrBundleSpot;
  homrContent?: any;
  homrGTGTContent?: HomrGTGTContent;
  homrInStoreServices?: any;
  homrRichContent?: IHomrRichContent;
  homrScheduleContent?: HomrScheduleContent;
  homrSpot?: IHomrSpot;
}
